import { useState } from "react";

//Utils
import { copyToClipboard } from "utils/commonUtility";

//Context
import { useAuth } from 'providers/AuthProvider';

export default function GetAuthToken(props) {
    const [clientId, setClientId] = useState("");
    const [clientSecret, setClientSecret] = useState("");
    const [XAPIKey, setXAPIKey] = useState("");
    const [authToken, setAuthToken] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [copied, setCopied] = useState(false);
    const { auth, updateAuth } = useAuth(); // Add this line to get authToken and update

    const getToken = async () => {
        setError(null);
        setAuthToken(null);
        setLoading(true);

        if (!clientId || !clientSecret) {
            setError("Client ID and Client Secret are required.");
            setLoading(false);
            return;
        }

        const url = props.url;
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded",
            "x-api-key": XAPIKey,
        };
        const body = new URLSearchParams({
            grant_type: "client_credentials",
            client_id: clientId,
            client_secret: clientSecret,
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                headers,
                body,
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.status} - ${response.statusText}`);
            }

            const data = await response.json();
            setAuthToken(data.access_token);

            // Update auth token in context
            updateAuth(data.access_token);

        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleCopy = () => {
        copyToClipboard(authToken, setCopied);
    };

    return (
        <>
            <div class="p-4 mb-2 text-sm text-blue-800 rounded-lg bg-blue-50" role="alert">
                <span class="font-medium">📘 Note:&ensp;</span>
                Use the test X API Key, client ID and client secret provided by BenePay.
                To obtain your X API Key, client ID and client secret, please contact <span class="font-medium">contact@benepay.io</span>.
            </div>
            <div className="p-4 rounded-lg shadow-md mx-auto">
                <h2 className="text-lg font-semibold mb-4">Request Parameters</h2>

                <div className="mb-4">
                    <label className="block text-gray-500 font-bold mb-2">X API Key</label>
                    <input
                        type="text"
                        value={XAPIKey}
                        onChange={(e) => setXAPIKey(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded"
                        placeholder="Enter X API KEY" />
                </div>

                <div className="mb-4">
                    <label className="block text-gray-500 font-bold mb-2">Client ID</label>
                    <input
                        type="text"
                        value={clientId}
                        onChange={(e) => setClientId(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded"
                        placeholder="Enter Client ID" />
                </div>

                <div className="mb-3">
                    <label className="block text-gray-500 font-bold mb-2">Client Secret</label>
                    <input
                        type="text"
                        value={clientSecret}
                        onChange={(e) => setClientSecret(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded"
                        placeholder="Enter Client Secret" />
                </div>

                <div className="text-end font-bold">
                    <button
                        onClick={getToken}
                        disabled={loading}
                        className={`w-24 py-2 rounded transition ${loading ? "bg-blue-500 text-white cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600 text-white"}`}
                    >
                        {loading ? "Loading..." : "Run"}
                    </button>
                </div>

                {error && <p className="text-red-500 mt-3">{error}</p>}

                {authToken && (
                    <div className="mt-4">
                        <div className="bg-gray-800 rounded-lg p-4">
                            <div className="text-green-500">Access token generated successfully. You can now use the APIs below.</div>
                            <div className="flex justify-between items-center mb-4 mt-3">
                                <span className="text-white font-semibold">RESPONSE</span>
                                <div className="flex gap-2">
                                    <span className="px-2 py-1 rounded bg-green-500 text-white text-xs">
                                        {'SUCCESS'}
                                    </span>
                                    <button
                                        onClick={handleCopy}
                                        className="bg-gray-700 hover:bg-gray-600 text-white px-2 py-1 rounded text-sm"
                                    >
                                        {!copied && <p className="font-bold">Copy</p>}
                                        {copied && <span className="text-xs ml-1 text-green-600 font-bold">Copied!</span>}
                                    </button>
                                </div>
                            </div>
                            <div className="w-full bg-gray-700 rounded-md p-3 text-sm relative">
                                <p className="text-gray-300 break-all">{authToken}</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
